import { ContractTerminationReason } from '../../../../common/types'
import { useTerminationReasonToLabel } from './useTerminationReasonToLabel'

export const useContractTerminationReasons = () => {
  const { terminationReasonToLabel } = useTerminationReasonToLabel()

  const contractTerminationReasons = [
    ContractTerminationReason.MOVE_TO_ANOTHER_MUNICIPALITY,
    ContractTerminationReason.FAMILY_SIZE_CHANGE,
    ContractTerminationReason.MOVE_DUE_WORK,
    ContractTerminationReason.APARTMENT_SIZE,
    ContractTerminationReason.POOR_APARTMENT_CONDITION,
    ContractTerminationReason.POOR_APARTMENT_EQUIPMENT_OR_PROPERTIES,
    ContractTerminationReason.APARTMENT_DOES_NOT_MEET_NEEDS,
    ContractTerminationReason.APARTMENT_TEMPERATURE,
    ContractTerminationReason.APARTMENT_LOCATION,
    ContractTerminationReason.POOR_PROPERTY_CONDITION,
    ContractTerminationReason.POOR_PROPERTY_MAINTENANCE,
    ContractTerminationReason.HOUSING_COSTS,
    ContractTerminationReason.STUDIES_END,
    ContractTerminationReason.RIGHT_OF_OCCUPANCY_ENDS,
    ContractTerminationReason.DISTURBING_NEIGHBOURS_OR_BUILDING,
    ContractTerminationReason.AREA_DISTURBANCES,
    ContractTerminationReason.AREA_POOR_SERVICES,
    ContractTerminationReason.POOR_TRANSPORTATION_OPTIONS,
    ContractTerminationReason.HEALTH_REASONS,
    ContractTerminationReason.DEATH,
    ContractTerminationReason.RENOVATION,
    ContractTerminationReason.BUSINESS_CLOSURE,
    ContractTerminationReason.BUSINESS_CLOSURE_IN_MUNICIPALITY,
    ContractTerminationReason.BUSINESS_STRUCTURE_CHANGE,
    ContractTerminationReason.SPACE_NEEDS_CHANGE,
    ContractTerminationReason.MOVE_TO_MORE_AFFORDABLE_BUSINESS_PREMISES_IN_MUNICIPALITY,
    ContractTerminationReason.OTHER,
  ].map((reason) => ({ id: reason, label: terminationReasonToLabel(reason) }))

  return { contractTerminationReasons }
}
